import { chain } from 'lodash';

export const globalFilterState = () => ({
  query: {
    start_time: '',
    end_time: '',
    time_type_text: '', // For Front-End Side.
    selectedFilterScopes: {}
  },
  filters: [],
  customProjectHasFilters: null,
  filter_tags: []
});

export const getters = {
  globalStoreFilters: state => chain(state.filters).filter(f => f.filter_scope === 'stores').sortBy('position').value(),
  globalSkuFilters: state => chain(state.filters).filter(f => f.filter_scope === 'skus').sortBy('position').value(),
  willGetProjectFiltersTagViaApi: state => state.customProjectHasFilters
};

export const mutations = {
  addGlobalFilters(state, payload) {
    state.filters = [
      ...state.filters,
      ...payload
    ];
  },
  setGlobalFilterStartDate(state, value) {
    state.query.start_time = value;
  },
  setGlobalFilterEndDate(state, value) {
    state.query.end_time = value;
  },
  setGlobalFilterTypeText(state, value) {
    state.query.time_type_text = value;
  },
  updateGlobalFilterScopes(state, payload) {
    state.query.selectedFilterScopes = payload.data;
    state.filter_tags = payload.tags;
  },
  resetGlobalFilterState(state) {
    state.query = {
      ...globalFilterState().query
    };
    state.filters = [
      ...globalFilterState().filters
    ];
  },
  addProjectCustomStatus(state, value) {
    state.customProjectHasFilters = value;
  }
};

export default {
  state: globalFilterState,
  getters,
  mutations
};
